import ContactForm from "@/components/Contact/ContactForm";

const ContactPage = () => {
  return (
    <div className="p-6">
      <ContactForm />
    </div>
  );
};

export default ContactPage;
